import React, { useMemo, useEffect } from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import { useIntl } from 'react-intl';
import objectPath from "object-path";
import { useSnackbar } from 'notistack';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { fetchStakeholdersByPin } from "../../../redux/features/stakeholder/stakeholderActions";
// _Metronic Components
import { useHtmlClassService } from "../../../_metronic/layout/_core/MetronicLayout";
import { Header } from "../../../_metronic/layout/components/header/Header";
import { HeaderMobile } from "../../../_metronic/layout/components/header-mobile/HeaderMobile";
import { Footer } from "../../../_metronic/layout/components/footer/Footer";
import { LayoutInit } from "../../../_metronic/layout/components/LayoutInit";
import { ScrollTop } from "../../../_metronic/layout/components/extras/ScrollTop";
// import { StickyToolbar } from "../../../_metronic/layout/components/extras/StickyToolbar";
import { AnimateLoading } from "../../../_metronic/_partials/controls";
// Components
// import MyGradeApplicationView from "../../components/GradeApplicationView";
// import GradeAppEdit from "../../modules/Unregistered/GradeAppEdit";
import Home from "./Home";
import Notifications from "../StakeholderCabinet/pages/Notifications/Notifications";
import SocketService from "../../../services/SocketService";
import StaticFormAppView from "../../components/RegistrationView/StaticFormAppView";
import RegisterAppEdit from "./RegisterAppEdit";

const Unregistered = ({ children }) => {

    const uiService = useHtmlClassService();

    const { enqueueSnackbar } = useSnackbar();
    const intl = useIntl();

    const dispatch = useDispatch();
    const { person } = useSelector(state => state.login);
    const { currentStakeholder } = useSelector(state => state.stakeholder);

    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, "self.layout"),
            asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
            subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                "header.self.fixed.desktop"
            ),
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses("content_container", true),
            contentExtended: objectPath.get(uiService.config, "content.extended"),
        };
    }, [uiService]);

    useEffect(() => {
        try {
            dispatch(fetchStakeholdersByPin(person?.pin, currentStakeholder?.voen));
            SocketService.join(currentStakeholder._id);
        } catch (err) {
            console.error(err);
            enqueueSnackbar(intl.formatMessage({ id: err?.response?.data.message || err.message }),
                { variant: 'error' });
        }
    }, [person]);


    return layoutProps.selfLayout !== "blank" ? (
        <>
            <AnimateLoading />
            <HeaderMobile />
            <div className="d-flex flex-column flex-root">
                <div className="d-flex flex-row flex-column-fluid page">
                    <div
                        className="d-flex flex-column flex-row-fluid wrapper"
                        id="kt_wrapper"
                    >
                        <Header />
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid justify-content-center`}
                        >
                            <div className="col-sm-10 offset-sm-1">
                                <Switch>
                                    {/* <Route path="/stakeholder/new/grade-application/edit" exact component={GradeAppEdit} /> */}
                                    <Route path="/stakeholder/new/profile-view/edit" exact component={RegisterAppEdit} />
                                    {/* <Route path="/stakeholder/new/grade-application" exact component={MyGradeApplicationView} /> */}
                                    <Route path="/stakeholder/new/profile-view" exact component={StaticFormAppView} />
                                    <Route path="/stakeholder/new/notifications/:id" exact component={Notifications} />
                                    <Route path="/stakeholder/new/notifications" exact component={Notifications} />
                                    <Route path="/stakeholder/new" exact component={Home} />
                                    <Redirect to="/stakeholder/new" />
                                </Switch>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            <ScrollTop />
            <LayoutInit />
        </>
    ) : (
        <div className="d-flex flex-column flex-root">{children}</div>
    );
}

export default Unregistered;
